import React from "react";
import "./SupportPhilosophySection.css";

const EmpathyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
  </svg>
);
const ClarityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 2a7 7 0 0 0-7 7c0 2.02 1.25 4.38 3.5 6.5A5.5 5.5 0 0 0 12 18a5.5 5.5 0 0 0 3.5-2.5C17.75 13.38 19 11.02 19 9a7 7 0 0 0-7-7z"></path>
    <path d="M12 9a3 3 0 0 0-3 3h6a3 3 0 0 0-3-3z"></path>
  </svg>
);
const TransparencyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
    <circle cx="12" cy="12" r="3"></circle>
  </svg>
);
const RespectIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M12 22a7 7 0 0 0 7-7h-4a3 3 0 0 1-3-3V2"></path>
    <path d="M5 15a7 7 0 0 1 7-7v10a3 3 0 0 0 3 3h4"></path>
  </svg>
);
const ConfidentialityIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
    <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
  </svg>
);

const philosophyItems = [
  {
    icon: <EmpathyIcon />,
    title: "Empathy",
    text: "Every question is important. Listen, reassure, and don’t judge.",
  },
  {
    icon: <ClarityIcon />,
    title: "Clarity",
    text: "Give step-by-step help—don’t assume prior knowledge.",
  },
  {
    icon: <TransparencyIcon />,
    title: "Transparency",
    text: "Always tell users what to expect and by when.",
  },
  {
    icon: <RespectIcon />,
    title: "Respect",
    text: "No shortcuts, no bias—treat all parties fairly, even in disputes.",
  },
  {
    icon: <ConfidentialityIcon />,
    title: "Confidentiality",
    text: "Handle personal and business data with care, always.",
  },
];

const SupportPhilosophySection = () => {
  return (
    <section className="_sPSec_h1A_">
      <div className="_sPCont_i2B_">
        <h2
          className="_pTitle_j3C_"
          style={{ paddingBottom: "1.3rem", marginBottom: "1.8rem" }}
        >
          Our Support Philosophy
        </h2>
        <ul className="_pList_k4C_">
          {philosophyItems.map((item, index) => (
            <li
              key={index}
              className="_pItem_l5D_ feature-item"
              style={{ borderRadius: "12px" }}
            >
              <div className="_pIconWrap_m6E_ feature-icon">{item.icon}</div>
              <div className="_pTextWrap_n7F_">
                <h3 className="feature-title-text">{item.title}</h3>
                <p className="feature-description">{item.text}</p>
              </div>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
};

export default SupportPhilosophySection;
